import React, {useEffect} from "react";
import { useElasticData, useExtraData } from "./DataContext.js";


const ReviewRatings = () => {
    let { ratingsData } = useElasticData();
    let { _source } = useExtraData();

    const RATINGS = {
        2 : 'Below Average', // 1 tick
        3 : 'Average', // 2 ticks
        4 : 'Good', // 3 ticks
        5 : 'Very Good' // 4 ticks
    };

    const r = _source;

    // Book page html
    useEffect(() => {

            // Load product data
            // Cleaning up
            // return () => {
                
            // };
        }, []
    );

    const ratingTicks = (property) => [5,4,3,2].map((i, k) => <span key={k} className={`${property === i ? 'checked' : ''}`}><label></label></span>);
    
    const fictionProduct = ['NF','JNF','TNF','ANF'].indexOf(r.category) == -1;


    const rd = ratingsData[0];

    return (
        <>
            {/* rvPlotRating */}
            {rd.rvPlotRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Plot<span className="searchToolTip">Is the plot plausible? Does it develop satisfactorily and flow well? Will it hold the reader's interest?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Currency<span className="searchToolTip">How up-to-date is the text and any statistics? Are geographical names accurate? Does it reflect the latest research/inventions?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Plot: ' : 'Currency: '} ${RATINGS[rd.rvPlotRating]}`}>
                        {ratingTicks(parseInt(rd.rvPlotRating))}
                    </div>
                </div>
            </div>}
            {/* rvCharacterRating */}            
            {rd.rvCharacterRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Characterisation<span className="searchToolTip">Are characters well drawn; do they develop as the story progresses? Are they full, convincing characters who are realistic within the context of the story?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Quality of illustrations<span className="searchToolTip">What type of illustrations are used e.g. B&amp;W or colour, photos or illustration? Are the illustrations clear? Are the photos or prints well reproduced?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Characterisation: ' : 'Quality of illustrations: '} ${RATINGS[rd.rvCharacterRating]}`}>
                        {ratingTicks(parseInt(rd.rvCharacterRating))}
                    </div>
                </div>
            </div>}
            {/* rvIllustrationRating */}
            {rd.rvIllustrationRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Illustrations<span className="searchToolTip">How well do the illustrations match the text? Do they add anything? Are they suitable for the intended age group? Is the artistic impression good (even if not to all tastes)?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Relevance of illustrations<span className="searchToolTip">What do the illustrations add to the book? Are they appropriate to the text? Can the reader extract information from the pictures – do they help explain the text?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Illustrations: ' : 'Relevance of illustrations: '} ${RATINGS[rd.rvIllustrationRating]}`}>
                        {ratingTicks(parseInt(rd.rvIllustrationRating))}
                    </div>
                </div>
            </div>}
            {/* rvAppealRating */}
            {rd.rvAppealRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Appeal<span className="searchToolTip">Will the content appeal to the intended readership, and is the cover attractive to browsers?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Text<span className="searchToolTip">Is the book well-written? Is it accurate and interesting? Does it explain things clearly and appropriately for the intended age level?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Appeal: ' : 'Text: '} ${RATINGS[rd.rvAppealRating]}`}>
                        {ratingTicks(parseInt(rd.rvAppealRating))}
                    </div>
                </div>
            </div>}
            {/* rvProductionRating */}
            {rd.rvProductionRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Production<span className="searchToolTip">Is the paper good quality; will the binding last? Is the typeface clear on the page and of an appropriate size and font? Are any paper engineering or novelty elements robust?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Layout<span className="searchToolTip">How clear is the type-face? Is it appropriate and attractive? How easy is information retrieval?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Production: ' : 'Layout: '} ${RATINGS[rd.rvProductionRating]}`}>
                        {ratingTicks(parseInt(rd.rvProductionRating))}
                    </div>
                </div>
            </div>}
            {/* rvStyleRating  */}
            {rd.rvStyleRating >= 2 && <div className="rating small">
                <div className="columns">
                    <div className="column">
                        {fictionProduct && <p className="needMore ratingDetails">Literary Style<span className="searchToolTip">How well written is the book? Is the dialogue natural? Does the language flow well, and is it appropriate for the intended age group? Are there non-UK spellings/terms; is the use of any slang/swearing gratuitous or inappropriate to intended readership?</span></p>}
                        {!fictionProduct && <p className="needMore ratingDetails">Production<span className="searchToolTip">Is the paper good quality; will the binding last? Is the typeface clear on the page and of an appropriate size and font? Are any paper engineering or novelty elements robust?</span></p>}
                    </div>
                    <div className="column" title={`${fictionProduct ? 'Literary Style: ' : 'Production: '} ${RATINGS[rd.rvStyleRating]}`}>
                        {ratingTicks(parseInt(rd.rvStyleRating))}
                    </div>
                </div>
            </div>}
        </>
    );
}

export default ReviewRatings;